<template>
  <el-drawer title="安全中心" :visible.sync="drawer" destroy-on-close :wrapperClosable="false" custom-class="widthCommon">
    <div class="box">
      <div v-for="(item, index) in optList" :key="index" class="item">
        <div class="top">
          <div class="left">
            <img :src="item.icon" alt="" class="icon" />
            <div class="content">
              <div class="title">{{ item.title }}</div>
              <div class="desc">{{ item.desc }}</div>
            </div>
          </div>
          <div
            class="btn"
            :class="{
              disabled: item.type === 3 && USER_INFO.enableOtp === 1 && USER_INFO.openOtp === 1,
              unbinding: item.type === 3 && USER_INFO.enableOtp === 0 && USER_INFO.openOtp === 1,
            }"
            @click="goDetail(item)"
          >
            <span v-if="item.type === 3">{{ USER_INFO.openOtp === 1 ? '解绑' : '绑定' }}</span>
            <span v-else>{{ item.btnText }}</span>
          </div>
        </div>
        <template v-if="item.tips">
          <ETips v-if="item.type === 3 && USER_INFO.enableOtp === 1" :marginLeft="52" :marginTop="8" padding="0" background="#ffffff" color="#666666" :left="8" :text="item.tips" />
        </template>
      </div>
    </div>
    <loginLog ref="loginLog" />
    <dynamicToken v-if="show.showDynamicToken" ref="dynamicToken" />
    <modifyPassword ref="modifyPassword" />
    <resetPassword ref="resetPassword" />
  </el-drawer>
</template>

<script>
import loginLog from '../loginLog'
import dynamicToken from '../dynamicToken'
import resetPassword from '../resetPassword'
import modifyPassword from '../modifyPassword'
import { unbindOptInfo } from '@/api/user'
export default {
  components: {
    modifyPassword,
    dynamicToken,
    resetPassword,
    loginLog,
  },
  provide() {
    return {
      securityCenterThis: this,
    }
  },
  data() {
    return {
      drawer: false,
      show: {
        showDynamicToken: false,
      },
    }
  },
  computed: {
    optList() {
      const list = [
        {
          title: '修改密码',
          icon: require('../../../assets/image/changePassword.png'),
          desc: '使用旧密码验证，设置新密码',
          btnText: '修改',
          tips: '管理员已为您设置开启动态令牌，您无法关闭',
          type: 1,
        },
        {
          title: '重置密码',
          icon: require('../../../assets/image/resetPassword.png'),
          desc: '忘记旧密码，使用手机号验证码重置',
          btnText: '重置',
          type: 2,
        },
        {
          title: '动态令牌',
          icon: require('../../../assets/image/dynamicToken.png'),
          desc: '在登录后台时，需填写动态令牌验证，通过验证后可访问系统，安全等级高',
          tips: '管理员已为您设置开启动态令牌，您无法关闭',
          btnText: '绑定',
          type: 3,
        },
        {
          title: '换绑动态令牌',
          icon: require('../../../assets/image/resetDynamicToken.png'),
          desc: '旧动态令牌无法使用，使用手机号验证码更换绑定',
          btnText: '换绑',
          type: 4,
        },
        {
          title: '登录日志',
          icon: require('../../../assets/image/loginLog.png'),
          desc: '查看最近90天的登录日志',
          btnText: '查看',
          type: 5,
        },
      ]
      return this.USER_INFO.openOtp === 1 ? list : list.filter(item => item.type !== 4)
    },
  },
  methods: {
    goDetail(item) {
      const { type } = item
      if (type === 1) {
        // 修改密码
        this.$refs.modifyPassword.drawer = true
      } else if (type === 2) {
        // 重置密码
        this.$refs.resetPassword.drawer = true
      } else if (type === 3) {
        // 动态令牌
        if (this.USER_INFO.openOtp === 1 && this.USER_INFO.enableOtp === 0) {
          // 解绑
          this.unbindOptInfo()
        } else if (this.USER_INFO.openOtp !== 1) {
          // 绑定
          this.show.showDynamicToken = true
          this.$nextTick(() => {
            this.$refs.dynamicToken.type = 1
            this.$refs.dynamicToken.drawer = true
          })
        }
      } else if (type === 4) {
        // 换绑动态令牌
        this.show.showDynamicToken = true
        this.$nextTick(() => {
          this.$refs.dynamicToken.type = 2
          this.$refs.dynamicToken.drawer = true
        })
      } else if (type === 5) {
        // 登录日志
        this.$refs.loginLog.drawer = true
      }
    },

    // 解绑动态令牌
    unbindOptInfo() {
      this.$msgbox({
        title: '解绑动态令牌',
        message: '您正在解绑动态令牌！解绑后只需要输入正确的账号密码即可访问后台，安全等级低，是否确认解绑？',
        showCancelButton: true,
        confirmButtonText: '确定',
        cancelButtonText: '取消',
      })
        .then(async action => {
          const { data: res } = await unbindOptInfo({})
          if (!res) return this.$message.error('解绑失败')
          this.$message.success('解绑成功')
          this.$store.dispatch('user/getInfo')
        })
        .catch(action => {})
    },
  },
}
</script>

<style lang="scss" scoped>
.box {
  padding: 36px 32px;
  .disabled {
    background: #9e9e9e !important;
    cursor: not-allowed !important;
  }
  .unbinding {
    background: #ea0000 !important;
  }
  .item {
    margin-bottom: 48px;

    .top {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .btn {
        width: 60px;
        height: 28px;
        border-radius: 8px;
        background: #31a8ff;
        color: #ffffff;
        font-size: 14px;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        margin-left: 24px;
      }
    }
    .left {
      display: flex;
      width: 100%;
      .icon {
        width: 36px;
        height: 36px;
        margin-right: 16px;
      }
      .content {
        .title {
          font-size: 16px;
          font-weight: 700;
          color: #3d3d3d;
          margin-bottom: 8px;
        }
        .desc {
          color: #666666;
          font-size: 14px;
        }
      }
    }
  }
}
</style>
